module.exports = __webpack_public_path__ + "static/media/closeIcon.1f3c315d.svg";